import React, { useCallback } from 'react';

export const withNamedCheckbox = (Checkbox, name) => {
  const WithNamedCheckbox = ({ onChange: onChangeProp, ...props }) => {
    const onChange = useCallback(
      (event) => {
        if (typeof onChangeProp !== 'function' || !event || !event.target) {
          return;
        }

        onChangeProp({ [name]: event.target.checked });
      },
      [onChangeProp]
    );

    return <Checkbox {...props} id={name} name={name} onChange={onChange} />;
  };

  WithNamedCheckbox.displayName = `withNamedCheckbox(${Checkbox.displayName || Checkbox.name})`;

  return WithNamedCheckbox;
};
